/**
 * Phe card — add variant from image size chips. Removable bundle (see phe-card-hover-sizes.liquid).
 */
(function () {
  'use strict';

  function getCartUi() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function closeAllPanels() {
    document.querySelectorAll('[data-phe-sizes-root]').forEach(function (root) {
      var fab = root.querySelector('[data-phe-sizes-fab]');
      var scrim = root.querySelector('[data-phe-sizes-scrim]');
      var panel = root.querySelector('[data-phe-sizes-panel]');
      if (fab) fab.setAttribute('aria-expanded', 'false');
      if (scrim) scrim.hidden = true;
      if (panel) panel.hidden = true;
    });
  }

  function openPanel(root) {
    closeAllPanels();
    var fab = root.querySelector('[data-phe-sizes-fab]');
    var scrim = root.querySelector('[data-phe-sizes-scrim]');
    var panel = root.querySelector('[data-phe-sizes-panel]');
    if (fab) fab.setAttribute('aria-expanded', 'true');
    if (scrim) scrim.hidden = false;
    if (panel) panel.hidden = false;
  }

  function togglePanel(root) {
    var panel = root.querySelector('[data-phe-sizes-panel]');
    if (!panel) return;
    if (panel.hidden) openPanel(root);
    else closeAllPanels();
  }

  function setLoading(root, isLoading) {
    if (!root) return;
    /* Use a root flag instead of disabling every chip — :disabled was styled like sold-out (line-through). */
    root.classList.toggle('phe-hover-sizes--adding', isLoading);
  }

  function addVariant(variantId, root, triggerBtn) {
    if (typeof fetchConfig !== 'function' || typeof routes === 'undefined' || !routes.cart_add_url) return;

    // Detect AMP Slide Cart via its injected root element or its method names.
    // Use method names (SLIDECART_UPDATE / SLIDECART_OPEN), not callback names.
    var hasAmpSlideCart = !!document.querySelector('#slidecarthq')
      || typeof window.SLIDECART_UPDATE === 'function'
      || typeof window.SLIDECART_OPEN === 'function';

    // Only request native section rendering when AMP is absent.
    var cartDrawer = hasAmpSlideCart ? null : getCartUi();

    var config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      formData.append('sections', cartDrawer.getSectionsToRender().map(function (section) {
        return section.id;
      }));
      formData.append('sections_url', window.location.pathname);
      if (typeof cartDrawer.setActiveElement === 'function') cartDrawer.setActiveElement(triggerBtn);
    }

    config.body = formData;
    setLoading(root, true);

    fetch(routes.cart_add_url, config)
      .then(function (res) {
        return res.json();
      })
      .then(function (response) {
        if (response.status) {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'phe-card-hover-sizes',
              productVariantId: String(variantId),
              errors: response.errors || response.description,
              message: response.message,
            });
          }
          return;
        }

        if (hasAmpSlideCart) {
          // AMP path: use SLIDECART_UPDATE() to re-fetch the cart inside AMP,
          // then open the drawer in its callback. SLIDECART_UPDATED (callback)
          // fires automatically after the update and our theme.liquid handler
          // picks it up to refresh the header counter.
          var openAmpDrawer = function () {
            if (typeof window.SLIDECART_OPEN === 'function') window.SLIDECART_OPEN();
            closeAllPanels();
          };

          if (typeof window.SLIDECART_UPDATE === 'function') {
            window.SLIDECART_UPDATE(openAmpDrawer);
          } else if (typeof window.SLIDECART_OPEN === 'function') {
            // SLIDECART_UPDATE not ready yet but OPEN is — open and AMP refreshes on activate.
            openAmpDrawer();
          } else {
            // AMP methods not yet initialised — fall back to cart page so add is not silent.
            closeAllPanels();
            window.location = routes.cart_url || '/cart';
          }
        } else if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          // Native cart drawer / notification path.
          var afterPublish = function () {
            cartDrawer.renderContents(response);
            closeAllPanels();
          };
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'phe-card-hover-sizes',
              productVariantId: String(variantId),
              cartData: response,
            }).then(afterPublish);
          } else {
            afterPublish();
          }
        } else {
          // No recognised cart UI — fall back to cart page.
          window.location = routes.cart_url || '/cart';
        }
      })
      .catch(function () {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'phe-card-hover-sizes',
            productVariantId: String(variantId),
            message: 'Unable to add to cart.',
          });
        }
      })
      .finally(function () {
        setLoading(root, false);
      });
  }

  document.addEventListener('click', function (e) {
    var fab = e.target.closest('[data-phe-sizes-fab]');
    if (fab) {
      e.preventDefault();
      e.stopPropagation();
      var rootFab = fab.closest('[data-phe-sizes-root]');
      if (rootFab) togglePanel(rootFab);
      return;
    }

    var scrim = e.target.closest('[data-phe-sizes-scrim]');
    if (scrim) {
      e.preventDefault();
      closeAllPanels();
      return;
    }

    var chip = e.target.closest('[data-phe-sizes-add]');
    var rootChip = chip ? chip.closest('[data-phe-sizes-root]') : null;
    if (
      chip &&
      !chip.disabled &&
      !chip.classList.contains('phe-hover-sizes__chip--sold-out') &&
      rootChip &&
      !rootChip.classList.contains('phe-hover-sizes--adding')
    ) {
      e.preventDefault();
      e.stopPropagation();
      var vid = chip.getAttribute('data-variant-id');
      if (vid && rootChip) addVariant(vid, rootChip, chip);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeAllPanels();
  });
})();
